import React, { useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from '../form/View'
import Footer from '../form/Footer'
import ReserveView from './ReserveView'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    flex: 1
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 36px'
  },
  img: {
    width:'75%',
    margin: '0 20px 40px'
  },
  welcomeMessage: {
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 'min(12vw, 36px)',
    color: theme.colors.primary,
    textAlign: 'center',

    fontSize: '42px',
    '@media(max-height: 976px)': {
      fontSize: '32px',
    },
  }
}))

function WelcomeStep (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ reserveView, setReserveView ] = useState(false)


  const reserve = () => {
    setReserveView(true)
  }

  if (reserveView) {
    return <ReserveView
      back={() => setReserveView(false)}
      next={props.next}
      index={props.index}
      numOfSteps={props.numOfSteps}
      private={props.private}
    />
  }

  return (
    <View className={styles.root}>
      <View className={styles.content}>
        { theme.logo && 
          <img 
            className={styles.img} 
            src={theme.logoUrl}
            alt="Logo" 
          />
        }
        <View className={styles.welcomeMessage}>
          {props.msg}
        </View>
      </View>
      <Footer 
        onNext={reserve}
        nextLabel='Iniciar'
        disableLogo={true}
      />
    </View>
  )
}

export default WelcomeStep